<template>
  <div
    v-if="show"
    class="modal d-block"
    style="background-color: rgba(0, 0, 0, 0.5);"
    tabindex="-1"
    @mousedown.self="onCancel"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content shadow">

        <div class="modal-header py-2">
          <h6 class="modal-title mb-0">
            <i class="fas fa-code me-2 text-muted"></i>Source code
          </h6>
          <button type="button" class="btn-close" @click="onCancel"></button>
        </div>

        <div class="modal-body p-0">
          <textarea
            v-model="code"
            class="form-control font-monospace border-0 rounded-0 badiu-source-textarea"
            spellcheck="false"
          ></textarea>
        </div>

        <div class="modal-footer py-2">
          <button
            type="button"
            class="btn btn-secondary btn-sm"
            @click="onCancel"
          >
            Cancel
          </button>

          <button
            type="button"
            class="btn btn-primary btn-sm"
            @click="onSave"
          >
            Save
          </button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
/**
 * BadiuTiptapSourceCode
 *
 * Isolated modal for viewing and editing raw HTML source code
 * (equivalent to TinyMCE's "code" plugin).
 */
import { ref, watch } from 'vue'

export default {
  name: "BadiuTiptapSourceCode",

  props: {
    show: {
      type: Boolean,
      default: false
    },

    html: {
      type: String,
      default: ""
    }
  },

  emits: ["save", "cancel"],

  setup(props, { emit }) {
    const code = ref("");

    watch(
      () => props.show,
      (visible) => {
        if (visible) {
          code.value = props.html || "";
        }
      },
      { immediate: true }
    );

    function onSave() {
      emit("save", code.value);
    }

    function onCancel() {
      emit("cancel");
    }

    return { code, onSave, onCancel };
  }
};
</script>

<style>
.badiu-source-textarea {
  height: 420px;
  font-size: 13px;
  line-height: 1.5;
  resize: vertical;
}
</style>
